import { Route } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../../app.constants';

import { UserRouteAccessService } from '../../shared';
import { AuthenticationComponent } from './authentication.component';

export const authenticationRoute: Route = {
  path: 'authentication',
  component: AuthenticationComponent,
  data: {
    needAuthentication: false,
    pageTitle: `Connexion${PAGE_TITLE_SUFFIX}`
  },
  canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/authentication/authentication.route.ts